import React from 'react'
import clsx from 'clsx';
import stylesQrCom from './qrcom.module.css';
import { SafeToUseSVG } from '../../utils/svgdata';

export default function AmoutToPay({ title, amount, safeToUse }: { title: string, amount: string, safeToUse: string }) {
  return (
    <>
      <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.bgamount, stylesQrCom.flexDirecColumn, stylesQrCom.br12, stylesQrCom.p1213, stylesQrCom.wperc100, stylesQrCom.gap11)}>
        <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.justifyContentBetween, stylesQrCom.flexDirecRow, stylesQrCom.wperc100)}>
        <div className={clsx(stylesQrCom.fontColorWhite)}>
            <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight600, stylesQrCom.lineHeight24, stylesQrCom.fontSize16)}>{title}</span>
        </div>
        <div className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight600, stylesQrCom.lineHeight24, stylesQrCom.fontSize16)}>
            <span className={clsx(stylesQrCom.fontColorWhite)}>{amount}</span>
        </div>
        </div>

        <hr className={clsx(stylesQrCom.hpx1, stylesQrCom.wperc100, stylesQrCom.hrborddot)} />

        <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.gap4)}>
            <span className={clsx(stylesQrCom.fontColorGray, stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.gap4, stylesQrCom.fontWeight500, stylesQrCom.lineHeight20, stylesQrCom.fontSize12)}>
                <SafeToUseSVG width={13} height={16} />
                {safeToUse}
                </span>
        </div>

      </div>
    </>
  )
}
